import { formatTimestamp } from '@/utils'

export default function MessageCellHeader({
    isMe,
    userDisplayName,
    timestamp,
}: {
    isMe: boolean
    userDisplayName: string
    timestamp: Date
}) {
    const containerClass = 'flex items-baseline pb-0.5 gap-2 w-full'
    const timestampClass = 'text-[10px] text-[#9b9b9b]'

    if (isMe) {
        return (
            <div className={`${containerClass} justify-end`}>
                <div className={timestampClass}>{formatTimestamp(timestamp)}</div>
                <div className="text-muse-yellow text-[12px] truncate">{userDisplayName}</div>
            </div>
        )
    } else {
        return (
            <div className={containerClass}>
                <div className="text-gray-300 text-[12px] truncate">{userDisplayName}</div>
                <div className={timestampClass}>{formatTimestamp(timestamp)}</div>
            </div>
        )
    }
}
